import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _MODAL_WIDTH;
var MODAL_WIDTH_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
var MODAL_WIDTH = (_MODAL_WIDTH = {}, _defineProperty(_MODAL_WIDTH, MODAL_WIDTH_SIZES.SMALL, '420px'), _defineProperty(_MODAL_WIDTH, MODAL_WIDTH_SIZES.MEDIUM, '576px'), _defineProperty(_MODAL_WIDTH, MODAL_WIDTH_SIZES.LARGE, '768px'), _MODAL_WIDTH);
export { MODAL_WIDTH, MODAL_WIDTH_SIZES };